import { Button, ButtonVariant } from "components/Form/Button";
import { Link } from "components/Link";

export function DeleteGenderAndEthnicity(props: { onClose: () => void }) {
  return (
    <div className="grid gap-6">
      <div className="grid gap-2 text-center">
        <h3 className="font-medium">Delete gender & ethnicity data</h3>
        <div>
          To delete your gender & ethnicity data, you'll be prompted to send an
          email to{" "}
          <Link to="mailto:contribute@toolsforhumanity.com">
            contribute@toolsforhumanity.com
          </Link>
        </div>
      </div>
      <div className="grid gap-2 grid-cols-2">
        <Button
          variant={ButtonVariant.FLAT}
          href={[
            "mailto:contribute@toolsforhumanity.com",
            "?subject=Delete gender & ethnicity data",
            "&body=I want to delete my gender and ethnicity data.",
          ].join("")}
        >
          Continue
        </Button>
        <Button onClick={props.onClose}>Done</Button>
      </div>
    </div>
  );
}
